<template>
  <div class="content">
	  <baseCrumbs  ></baseCrumbs>
    <!-- 售后单操作 -->
    <div class="base_content mt10 order-info">
      <div class="order_boxshou">
        <div class="order_info_tit">单据信息</div>
        <div class="info_itembox">
          <div class="item">订单编号：{{orderInfo.order_sn || ''}}</div>
          <div class="item">订单金额：{{orderInfo.payable_price || ''}}</div>
          <div class="item">创建日期：{{orderInfo.created_at || ''}}</div>
          <div class="item" >备注：<el-input v-model="remarks" style="width:200px" size="small" placeholder="请输入内容"></el-input></div>
          <div class="item" style="opacity: 0;">开票日期：{{orderInfo.created_at || ''}}</div>
          <div class="item" style="opacity: 0;">开票日期：{{orderInfo.created_at || ''}}</div>
        </div>
      </div>
    </div>
    <!-- 订单商品 -->
    <div class="base_content mt10 order-info">
      <div class="order_info_tit">商品信息</div>
      <baseTable :list="orderInfo.detail" :tableList="tableForm">
        <!-- 商品信息 -->
        <template #info="scope">
          {{ scope.row.goods.goods_name }}
        </template>
        <!-- 商品单价 -->
        <template #goods_price="scope">
          <span class="fw600">￥{{ scope.row.goods.goods_price_min }}</span>
        </template>
		<template #unit="scope">
		  <span class="fw600">{{ scope.row.goods.unit_name }}</span>
		</template>
		<template #verify_number="scope">
		  <el-input v-model="scope.row.verify_number" size="small" placeholder="请输入内容"></el-input>
		</template>
		<template #verify_price="scope">
		  <el-input v-model="scope.row.verify_price" size="small" placeholder="请输入内容"></el-input>
		</template>
		<template #remarks="scope">
		  <el-input v-model="scope.row.remarks" size="small" placeholder="请输入内容"></el-input>
		</template>
      </baseTable>
    </div>
    <!-- 返回 -->
	<div class="base_fixed_bottom">
		<el-button class="base_but_style" @click="sureFun()">确认对账</el-button>
    </div>
  </div>
</template>
<script>
	import { eltips } from "@/util/util.js";
import baseTable from "@/components/common/baseTable.vue";
import baseModal from "@/components/common/baseModal.vue";

export default {
  components: {
    baseTable,
    baseModal,
  },
  data() {
    return {
		crumbs:[],
		remarks:'',
      active: 1,
      orderInfo: {},
      tableForm: [
        { label: "商品名称", prop: "info" },
        { label: "单位", prop: "unit",default:'0' },
        { label: "数量", prop: "number",default:'0' },
        { label: "单价", prop: "goods_price",default:'0' },
        { label: "对账数量", prop: "verify_number",default:'0' },
        { label: "对账金额", prop: "verify_price",default:'0' },
        { label: "备注", prop: "remarks",default:'0' },
      ],
      srcList: [],
    };
  },
  created() {
    let _this = this;
    this.getDetail();
  },
  mounted() {
  },
  methods: {
	  sureFun(){
		  let _this = this;
		  let pos = {
			  remarks:this.remarks,
			  list:[]
		  }
		  if(_this.orderInfo.detail.length>0){
			 _this.orderInfo.detail.map(red=>{
				  pos.list.push({
					  verify_number:red.verify_number,
					  verify_price:red.verify_price,
					  goods_id:red.goods_id,
					  goods_sku_id:red.goods_sku_id,
					  number:red.number,
					  price:red.price,
					  remarks:red.remarks,
					  supplier_remarks:red.supplier_remarks,
					  id:red.id
				  })
			  })
		  }
		  _this.axios.post("/api/weishop/admin/plugin/erp/bill-order/verify/" + this.$route.query.id,pos)
		    .then((res) => {
		      if (res.code == 200) {
				  eltips(res.msg, "success");
		      } else {
		        eltips(res.msg, "error");
		      }
		    });
	  },
    toback() {
				this.$router.go(-1);
			},
    // 查询订单详情
    getDetail() {
      let _this = this;
      _this.axios
        .get("/api/weishop/admin/plugin/erp/bill-order/detail/" + this.$route.query.id)
        .then((res) => {
          if (res.code == 200) {
			  
            this.orderInfo = res.data;
          } else {
            eltips(res.msg, "error");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content{
  padding-bottom: 100px;
}
// 订单状态
.status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  .els {
    display: flex;
    justify-content: center;
    flex: 1;
    margin-left: 270px;
  }
}
// 订单详情
.order-info {
  padding: 30px 20px;
  .tips {
    background: rgba(25, 137, 250, 0.1);
    border: 1px solid #006aff;
    padding: 5px 12px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .el-icon-question {
      color: #006aff;
      font-size: 15px;
      margin-right: 5px;
    }
  }
  .btnbox {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 20px;
    .btn {
      padding: 6px 15px;
      //   border: 1px solid #b8b8b8;
      margin-right: 10px;
      color: #fff;
      background: #006aff;
    }
  }
  .info_itembox {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    .item {
      width: 33%;
      font-size: 14px;
      color: #000;
      margin-bottom: 10px;
    }
    & > :nth-last-child(-n + 4) {
      margin-bottom: 0;
    }
  }
}
.order_info_tit {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000;
}
// 商品信息
.goods_item {
  display: flex;
  align-items: center;
  .goods_img {
    img {
      width: 60px;
    }
  }
  .good_info {
    text-align: left;
    .info_name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 显示 2 行 */
      overflow: hidden;
      text-overflow: ellipsis; /* 超出部分使用省略号表示 */
    }
    .info_sku {
      color: gray;
      font-size: 12px;
    }
  }
}
.base_fixed_bottom {
  position: fixed;
  width: calc(100vw - 180px);
  bottom: 0;
  z-index: 999;
}
/deep/.el-step__head.is-success {
  border-color: #006aff;
  color: #006aff;
}
/deep/.el-step__title.is-success {
  color: #006aff;
}
/deep/.el-step__description.is-success {
  color: #006aff;
}
</style>
